/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Resource } from '../models/resource';
import { ResourceDeleteResp } from '../models/resource-delete-resp';

@Injectable({
  providedIn: 'root',
})
export class ResourceService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation resourceGet
   */
  static readonly ResourceGetPath = '/resource/{uuid}';

  /**
   * Get resource
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceGet$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ResourceService.ResourceGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Get resource
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceGet(params?: {
  }): Observable<void> {

    return this.resourceGet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation resourceDelete
   */
  static readonly ResourceDeletePath = '/resource/{uuid}';

  /**
   * Delete a resource
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceDelete$Response(params: {

    /**
     * Resource uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<ResourceDeleteResp>> {

    const rb = new RequestBuilder(this.rootUrl, ResourceService.ResourceDeletePath, 'delete');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResourceDeleteResp>;
      })
    );
  }

  /**
   * Delete a resource
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceDelete(params: {

    /**
     * Resource uuid
     */
    uuid: string;
  }): Observable<ResourceDeleteResp> {

    return this.resourceDelete$Response(params).pipe(
      map((r: StrictHttpResponse<ResourceDeleteResp>) => r.body as ResourceDeleteResp)
    );
  }

  /**
   * Path part for operation resourceUploadImage
   */
  static readonly ResourceUploadImagePath = '/resource/image';

  /**
   * ResourceUploadImage
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceUploadImage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  resourceUploadImage$Response(params: {
    body: {
'image'?: Blob;
}
  }): Observable<StrictHttpResponse<Resource>> {

    const rb = new RequestBuilder(this.rootUrl, ResourceService.ResourceUploadImagePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Resource>;
      })
    );
  }

  /**
   * ResourceUploadImage
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceUploadImage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  resourceUploadImage(params: {
    body: {
'image'?: Blob;
}
  }): Observable<Resource> {

    return this.resourceUploadImage$Response(params).pipe(
      map((r: StrictHttpResponse<Resource>) => r.body as Resource)
    );
  }

}
